import { useCallback as e, useEffect as t, useRef as n } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useThrottleUpdates.ts
var r = 100, i = (i, a = r) => {
	let o = n(i), s = n(null), c = n(null), l = n(null), u = n(() => void 0);
	t(() => {
		o.current = i;
	}, [i]), t(() => () => {
		s.current && clearTimeout(s.current);
	}, []);
	let d = e((e) => {
		o.current && o.current(e), c.current = e;
	}, []);
	return t(() => {
		u.current = () => {
			l.current && l.current !== c.current ? (d(l.current), s.current = setTimeout(() => u.current(), a)) : s.current = null;
		};
	}, [a, d]), e((e) => {
		if (l.current = e, a <= 0) {
			d(e);
			return;
		}
		s.current ||= (d(e), setTimeout(() => u.current(), a));
	}, [a, d]);
};
//#endregion
export { i as useThrottleUpdates };
